import Vue from "vue";
import App from "./App.vue";
import "./assets/styles/ion-icon.css";
import "./assets/styles/tailwind.css";
import "./assets/styles/app.sass";
import "./plugins";
import "./directives";
import store from "./store";
import router from "./router";
import { i18n } from "@/plugins/i18n";
import { init } from "@amplitude/analytics-browser";

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

const AMPLITUDE_API_KEY =
  process.env.NODE_ENV === "production"
    ? process.env.VUE_APP_AMPLITUDE_API_KEY
    : process.env.VUE_APP_AMPLITUDE_API_KEY_DEV;

if (AMPLITUDE_API_KEY) {
  init(AMPLITUDE_API_KEY, {
    autocapture: {
      attribution: true,
      pageViews: true,
      sessions: true,
      formInteractions: true,
      fileDownloads: true,
      elementInteractions: true,
    },
  });
}

const app = new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
});

app.$mount("#app");

export { app };
